const PropertyPerformanceSkeleton = () => (
  <div className="skeleton-section-card">
    <div className="skeleton" style={{ height: 20, width: 160, marginBottom: 16 }} />
    <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height: 30, width: 100 }} />
      ))}
    </div>
    {Array.from({ length: 5 }).map((_, i) => (
      <div key={i} className="skeleton-table-row">
        <div className="skeleton skeleton-table-cell" />
        <div className="skeleton skeleton-table-cell" />
        <div className="skeleton skeleton-table-cell" />
        <div className="skeleton skeleton-table-cell" />
        <div className="skeleton skeleton-table-cell" />
      </div>
    ))}
  </div>
);

export default PropertyPerformanceSkeleton;
